//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import Filters from './StatisticsReferralsFilters.vue';
import constant from '~/const';
import tableConfig from './tableConfig';

export default {
  components: { Filters },

  data() {
    return {
      tableConfig,
      constant,
      selection: [],
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('statisticsReferrals', ['data', 'referrersNumber', 'referralsNumber']),

  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('statisticsReferrals', {
      loadDataAction: 'loadData',
      setPageAction: 'setPage',
    }),

    async applyFilters() {
      try {
        this.setGeneralLoader(true);
        await this.loadDataAction();
        this.setGeneralLoader(false);
      } catch (error) {
        this.setErrorNotification(error.message);
      }
    },

    setPage(value) {
      this.setPageAction(value);
      this.loadDataAction();
    },
  },
};
